import { createReducer, on } from '@ngrx/store';
import { AuthState, initialAuthState } from './auth.model';
import * as AuthActions from './auth.action';

export const authReducer = createReducer(
  initialAuthState,

  on(AuthActions.login, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),

  on(AuthActions.loginSuccess, (state, { user, token }) => ({
    ...state,
    user,
    id: user.id,
    token,
    isLoading: false,
    error: null,
    roleId: user.role_id || null
  })),

  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error
  })),

  on(AuthActions.logout, (state) => ({
    ...initialAuthState
  })),

  on(AuthActions.loadAuthDataFromLocalStorage, (state, { user, token,permissions }) => ({
    ...state,
    user,
    id: user?.id || null,
    roleId: user?.role_id || null,
    token,
    permissions: permissions || null,
  })),

  on(AuthActions.setPermissionsRole, (state, { permissions }) => ({
    ...state,
    permissions: permissions || {},
  }))



);